// Export the Component Definition for use in Contentful Studio
export {ParagraphContentfulComponentDefinition} from './ParagraphContentfulDefinition';
export {default} from './Paragraph';
